import styled, {css} from 'styled-components';

export const SpecialOfferMainWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.xxlarge};
    box-shadow: 0 3px 30px 0  ${props.theme.colors.black.light1};
  `
);

export const SpecialOfferHeaderWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    align-itmes: center;
    justify-content: space-between;
    padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l30};
  `
);

export const SpecialOfferHeadText = styled.p(
  props => `
    font-size: 2.8rem;
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.black};
  `
);

export const SplOfferCaroIconWrap = styled.div(
  props => `
    width: 10%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  `
);

export const IconInnerWrapCaro = styled.div(
  props => `
    display: flex;
    width: 6.8rem;
    height: 3rem;
    align-items: center;
    border-radius: 20px;
    box-shadow: 0 1px 6px 0 ${props.theme.colors.black.light2};
    background-color: ${props.theme.colors.white.base};
  `
);

export const LeftIconWrapCaro = styled.div(
  props => `
    width:50%;
    display: flex;
    justify-content: center;
    pointer-events: ${props.disabled ? 'none' : ''};
  `
);

export const RightIconWrapCaro = styled.div(
  props => `
    width:50%;
    display: flex;
    justify-content: center;
    pointer-events: ${props.disabled ? 'none' : ''};
  `
);

export const SpecialOfferCaroOuterWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    padding: ${props.theme.spacing.nospacing} ${props.theme.spacing.nospacing} ${props.theme.spacing.small.s5}  ${props.customMargin ? `9rem` :  props.theme.spacing.large.l12 };
    overflow: hidden;
  `
);

export const SpecailOfferCaroInnerWrap = styled.div(
  props => `
    width:93%;
    display: flex;
    overflow:auto;
    padding-bottom: ${props.theme.spacing.large.l11};
    padding-left: ${props.theme.spacing.small.s5};
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
        display: none;
    }
    margin-left: 15px;

  `
)

export const SpecialOfferCaroList = styled.div(
  props => `
    width:37rem;
    height: 17rem;
    display: flex;
    align-items: flex-end;
    margin-right: ${props.theme.spacing.large.l20};
    marign-bottom: ${props.theme.spacing.large.l30};
    z-index:2;
    cursor: ${!props.disabled ? 'pointer' : ''};
    `
);

export const SpecialOfferCardInfoWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    height: 15rem;
    border-radius: ${props.theme.misc.borderRadius.large};
    box-shadow: 0 1px 6px 0 ${props.theme.colors.black.light2};
    background-color: ${props.theme.colors.white.base};
    position: relative;
  `
);


export const CaroCardLeftBlock = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 15rem;
    width: 19rem;
    justify-content: flex-end;
  `
);


export const SpecialOfferImgWrap = styled.div(
  props => `
    position: absolute;
    bottom: 3.2rem;
    left: 2rem;
    width: 15rem;
    height: 13.8rem;
    border-radius: ${props.theme.misc.borderRadius.large};
  `
);

export const SpecialOfferCaroImg = styled.img(
  props => `
    width: 15rem;
    height: 13.8rem;
    border-radius: ${props.theme.misc.borderRadius.large};
  `
);

export const OfferVaildTextWrap = styled.div(
  props => `
    position: absolute;
    bottom: 2.1rem;
    left:3.9rem;
    padding: ${props.theme.spacing.small.s7} ${props.theme.spacing.base};
    background-color: ${props.theme.colors.black.base};
    border-radius: 3.5rem;
    margin-bottom: ${props.theme.spacing.small.s5}

  `
);

export const OfferValidText = styled.p(
  props => `
    font-size: ${props.theme.font.small.font10};
    font-weight: ${props.theme.font.fontWeight.bold};
    color: ${props.theme.colors.white.base};

  `
);

export const TnCTextWrap = styled.div(
  props => `
    display: flex;
    padding-bottom: ${props.theme.spacing.small.s9};
  `
);

export const TnCText = styled.p(
  props => `
    font-size: ${props.theme.font.small.font10};
    color: ${props.theme.colors.grey.base};
  `
);

export const CaroCardRightBlock = styled.div(
  props => `
    width:16rem;
    display: flex;
    flex-direction: column;
    position: relative;
    left : 1rem;
    padding: ${props.theme.spacing.large.l11} ${props.theme.spacing.large.l11} ${props.theme.spacing.large.l11} ${props.theme.spacing.nospacing}
  `
);

export const DestTypeWrap = styled.div(
  props => `
    position: absolute;
    top: -17px;
    left: 0;
  `
);

export const DestTypeText = styled.p(
  props => `
    font-size: ${props.theme.font.base};
    font-weight: ${props.theme.font.fontWeight.black};
    color: ${props.theme.colors.grey.lightc2};
    text-transform: ${props.theme.font.textTransform.upper};
  `
);

export const OfferTextWrap = styled.div(
  props => `
    display: flex;
    width: 100%;
    padding-bottom: ${props.theme.spacing.large.l12}
  `
);

export const OfferText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font14};
    font-weight: ${props.theme.font.fontWeight.black};
    color: ${props.theme.colors.black.base};
  `
);

export const SmallBorderBlock = styled.div(
  props => `
    width: 3.5rem;
    height: .3rem;
    background-color: ${props.theme.colors.red.base};
    margin-bottom: ${props.theme.spacing.small.s5}
  `
);

export const OfferDetailWrap = styled.div(
  props => `
    width: 100%;
    display: flex;
  `
);

export const offerDetailText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.light9b};
    font-weight: ${props.theme.font.fontWeight.bold};

    span{
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
    }
  `
);

export const SplMadeTag = styled.div(
  props => `
    width:90%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 3rem;
    background-color: ${props.theme.colors.green.lgihtc1};
    border-radius: 0 0 4px 4px;
    position: absolute;
    bottom: -3rem;
    left: 5%;
    z-index: 1;
  `
);

export const SpLmadeTagText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.green.base};
    font-weight: ${props.theme.font.fontWeight.bold};
  `
);
